// src/api/baseURL.js
const API_URL = process.env.REACT_APP_API_BASE_URL;
export default API_URL;
